import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface ProcedureTrainingFilters
	extends Record<string, string[] | number[]> {
	jobTitleIds: number[];
	trainingNames: string[];
	workStationIds: number[];
	coordinationIds: number[];
	management: string[];
	locations: string[];
	mappingResponsibleIds: number[];
}

const numberArrayChecker = r.array(r.number()) as r.Checker<number[]>;
const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;
const optionalNumberArrayChecker = r.custom<number[]>((value) => {
	if (Array.isArray(value)) {
		return value.map((item) => Number(item)).filter((item) => !Number.isNaN(item));
	}

	return [];
});

const procedureTrainingFiltersAtom = atom<ProcedureTrainingFilters>({
	key: 'procedureTrainingFilters',
	default: {
		jobTitleIds: [],
		trainingNames: [],
		workStationIds: [],
		coordinationIds: [],
		management: [],
		locations: [],
		mappingResponsibleIds: [],
	},

	effects: [
		urlSyncEffect<ProcedureTrainingFilters>({
			refine: r.object({
				jobTitleIds: numberArrayChecker,
				trainingNames: stringArrayChecker,
				workStationIds: numberArrayChecker,
				coordinationIds: numberArrayChecker,
				management: stringArrayChecker,
				locations: stringArrayChecker,
				mappingResponsibleIds: optionalNumberArrayChecker,
			}),
			history: 'push',
		}),
	],
});

export { procedureTrainingFiltersAtom };
